import { render } from "./InstitutionsList.vue?vue&type=template&id=d5cee880&lang=pug"
import script from "./InstitutionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__